import { Role } from '@gripp/shared-logic';
import { AccountTypeMenu } from './accountTypeMenu';

export interface onPressProps {
  id: string;
  selectedRoles: string[];
  action?: 'accountType' | 'remove';
}

export const getAccountColumn = (
  workspaceId: string | undefined,
  info: any,
  roleList: Role[] = [],
  showGlobalAdminRole: boolean,
  onPress: (props: onPressProps) => Promise<void>,
  currentUserRole?: string
) => {
  const account = info.row.original;
  const { id, workspaceRoles } = account || {};

  if (!id || !workspaceRoles || workspaceRoles.length === 0) {
    return null;
  }

  return (
    <AccountTypeMenu
      onPress={onPress}
      roleList={roleList}
      account={account}
      workspaceId={workspaceId}
      showGlobalAdminRole={showGlobalAdminRole}
      currentUserRole={currentUserRole}
    />
  );
};
